import { render, staticRenderFns } from "./DatetimeColorCobroFormatter.vue?vue&type=template&id=7aa4bb90&functional=true&"
import script from "./DatetimeColorCobroFormatter.vue?vue&type=script&lang=js&"
export * from "./DatetimeColorCobroFormatter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports